import { FormFieldType } from '@Shared.Angular/flowingly.services/flowingly.constants';
import IActionButtons from './actionButtons';
import ILookupConfig from './lookupConfig';
import IValidation from './validation';
import IOption from './option';
import ICustomValidation from './customValidation';
import IFormulaConfig from './formulaConfig';
import { Guid } from '@Shared.Angular/@types/guid';
import { ISubFieldVisibility } from '../externalBusinessProvider/externalBusinessProvider';
import IDbDataSource from './dbDataSource';
import IFieldCondition from './fieldCondition';
import { INotifyField } from '../flows/fieldForUser';

export enum FormFieldLayout {
  Vertical = 0,
  Horizontal = 1
}

export default interface IFormField {
  actionButtons: IActionButtons;
  alignment: string;
  attachDocumentFileIds: string[];
  conditions?: IFieldCondition[] | null;
  customUnits: any;
  customValidation?: ICustomValidation;
  dataSource: any;
  dbDataSource: IDbDataSource;
  defaultFormFieldId: any;
  defaultPreviousStepId: any;
  defaultValueOption: string;
  disabled: boolean;
  displayInCompletedSteps: any;
  displayName: string;
  showDisplayName: boolean;
  formulaConfig: IFormulaConfig;
  hideByDefault: any;
  id: string;
  instruction: any;
  layout?: FormFieldLayout | null;
  label: any;
  lookupConfig: ILookupConfig;
  addressProviderId: number;
  externalBusinessProviderId?: number;
  subFieldVisibility?: ISubFieldVisibility;
  name: string;
  nodeId?: Guid;
  noLabel: boolean;
  options: IOption[];
  placeholder: any;
  procedureId?: Guid;
  searchable: boolean;
  tableSchema: any;
  tooltip: any;
  type: FormFieldType;
  typeName: string;
  validation: IValidation;
  value: string;
  notifyFields?: INotifyField[];
  locked: boolean;
  hideInDesigner: boolean;
  filteredOptions?: IOption[];
}
